import axios from "axios";
import config  from '../../env.json';

function getRoles(callback:any){
    try {
      axios({
        method: 'get',
        url:config.REACT_APP_AUTH_API_BASE+'/rolespermisson/getroles',
      })  
        .then(res=>{ 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
   
}
function getPermissions(payload:number,callback:any){
    try {
      axios({
        method: 'get',
        url:config.REACT_APP_AUTH_API_BASE+'/rolespermisson/permissionsbyroleid/'+payload,
      })  
        .then(res=>{ 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
}
function updatePermission(payload:any,callback:any){
    try {
      axios({
        method: 'post',
        url:config.REACT_APP_AUTH_API_BASE+'/rolespermisson/updatepermissions',
        data:payload,
      })  
        .then(res=>{ 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
}
 

export {getRoles,getPermissions,updatePermission}